export default "__VITE_ASSET__BqU1ftRi__"